import { createHead } from '@unhead/vue/client'
import FloatingVue from 'floating-vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import '@unocss/reset/tailwind.css'
import 'floating-vue/dist/style.css'
import 'uno.css'
import './styles/main.css'

const app = createApp(App)
app.use(createPinia())
app.use(createHead())
app.use(router)
app.use(FloatingVue)
app.mount('#app')
